var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 144,
    viewBox: "0 0 137 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 48.82V32.1H120.68V24.1H112.69V16.19H104.7V16H104.51V8.00999H85.04V0.019989H53.16V8.00999H32.76V16V16.19H24.77V24.1H16.77V32.1H8.78003V48.82H0.790039V80.26H8.78003V95.93H16.77V111.92H24.77V119.91H32.76V127.91H48.75V135.9H88.7101V127.91H104.7V119.91H112.69V111.92H120.68V95.93H128.68V80.26H136.67V48.82H128.68Z",
    fill: "#FDAE35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0501 135.92H53.1602V143.91H85.0501V135.92Z",
    fill: "#D38B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 80.26V95.91H120.68V103.91H112.69V111.9H104.7V119.89H96.7102V127.88H96.7502L96.7102 127.91H85.2002V135.9H104.7V127.88H112.69V119.89H120.68V111.9H128.68V96.24H136.67V80.26H128.68Z",
    fill: "#D38B2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.32 135.9V127.91H40.75L40.7 127.88H40.75V119.89H32.76H32.59V111.9H24.77V103.91H16.77V95.91H8.78003V80.26H0.790039V96.24H8.78003V111.9H16.77V119.89H24.59H24.77V127.88H32.76V135.9H53.32Z",
    fill: "#D38B2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.69 23.83H96.7002V31.82H104.69V23.83Z",
    fill: "#FFEBD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.71 20H92.71V24H96.71V20Z",
    fill: "#FFDAA9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 31.82H104.7V35.82H108.7V31.82Z",
    fill: "#FFDAA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.69 78.47H80.7202V86.46H112.69V78.47Z",
    fill: "#A32732"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.74 78.47H24.77V86.46H56.74V78.47Z",
    fill: "#A32732"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.77 57.26H56.74V78.47H64.73V57.26H72.73V77.62H80.72V57.26H88.7101H96.7101H112.69V77.62H120.68V49.27H16.77V77.62H24.77V57.26Z",
    fill: "#A32732"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.74 57.26H24.77V78.47H56.74V57.26Z",
    fill: "#ECF0F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.69 57.26H80.7202V78.47H112.69V57.26Z",
    fill: "#ECF0F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5005 65.59V62.01H38.5805V65.59H48.5005Z",
    fill: "#A32732"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5803 65.55H35.0303V69.1H38.5803V65.55Z",
    fill: "#A32732"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0602 65.55H48.5103V69.1H52.0602V65.55Z",
    fill: "#A32732"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7002 65.59V62.01H89.7802V65.59H99.7002Z",
    fill: "#A32732"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7703 65.55H86.2202V69.1H89.7703V65.55Z",
    fill: "#A32732"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.26 65.55H99.7104V69.1H103.26V65.55Z",
    fill: "#A32732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryCorrect);
export default __webpack_public_path__ + "static/media/query_correct.5c497f642a4b240451fa8a17277eed63.svg";
export { ForwardRef as ReactComponent };